import { render } from "./InputContactNumber.vue?vue&type=template&id=bec34948&scoped=true"
import script from "./InputContactNumber.vue?vue&type=script&lang=js"
export * from "./InputContactNumber.vue?vue&type=script&lang=js"

import "./InputContactNumber.vue?vue&type=style&index=0&id=bec34948&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec34948"]])

export default __exports__